import { render, staticRenderFns } from "./CustomerServiceHost.vue?vue&type=template&id=3aa4b205"
import script from "./CustomerServiceHost.vue?vue&type=script&lang=js"
export * from "./CustomerServiceHost.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceHost.vue?vue&type=style&index=0&id=3aa4b205&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports